import React, { useEffect, useState } from 'react';

import { Card, Button, Form, InputGroup} from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import LocaleHandler from '../../../LocaleHandler';
import 'react-toastify/dist/ReactToastify.css';
import './MyAccount.scss';




function MyAccount(props) {
    const auth = useAuth();
    const t = useTranslate();  
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const { setLocale } = React.useContext(LocaleHandler);


    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });
    
    const [user, setUser] = useState<Object>({});

    const [passVerify, setPassVerify] = useState("");

    function saveUser() {
        if (user["password"] != "" && user["password"] != passVerify) {
            notifyWarning(t("myaccount.toast_twarning_passwordmismatch"));
            setUser({ ...user, password: "" });
            setPassVerify("");
            return null;
        }
        axios.all([
            axios.single({
                method: "put",
                url: "/api/users/me",
                data: { ...user },
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setUser(res[0].data);
            let user = JSON.parse((localStorage.getItem("user") as string));
            user.userdata = res[0].data;
            localStorage.setItem('user', JSON.stringify(user));
            setLocale(res[0].data.language);
            setPassVerify("");
            notifySuccess(t("myaccount.toast_user_saved"));
        }))
        .catch(err => console.log(err));
    }

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/users/me",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setUser(res[0].data);
        }))
        .catch(err => console.log(err));
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="maincontent">
            <div className="myaccount-container">
                <Card>
                    <Card.Body>
                        <h3>{t("myaccount.page_name")}</h3>
                        <hr/>
                        {user["email"] != undefined ?
                            <div>
                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>{t("users.new_name")}:</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="text" placeholder={t("users.new_name")} onChange={evt => setUser({...user, name: evt.target.value})} value={user["name"]}></Form.Control>
                                </InputGroup>
                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>{t("users.new_email")}:</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="text" disabled={user["role"] != undefined ? (user["role"][0] != "Admin") : true} placeholder={t("users.new_email")} onChange={evt => setUser({...user, email: evt.target.value})} value={user["email"]} ></Form.Control>
                                </InputGroup>
                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>{t("users.new_password")}:</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="password" autoComplete="new-password" placeholder={t("users.new_password")} onChange={evt => setUser({...user, password: evt.target.value})} value={user["password"]} ></Form.Control>
                                </InputGroup>
                                {user["password"] != "" ?
                                    <InputGroup className="mb-3">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text>{t("users.verify_new_password")}:</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control type="password" autoComplete="new-password" placeholder={t("users.verify_new_password")} onChange={evt => setPassVerify(evt.target.value)} value={passVerify} ></Form.Control>
                                    </InputGroup>
                                : null}
                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>{t("users.new_mobile")}:</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="text" placeholder={t("users.new_mobile")} onChange={evt => setUser({...user, phone: evt.target.value})} value={user["phone"]} ></Form.Control>
                                </InputGroup>
                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>{t("users.language")}:</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control as="select" onChange={evt => { setUser({...user, language: (evt.target as HTMLSelectElement).value}); }} value={user["language"]} >
                                        <option value="no">{t("users.language_norwegian")}</option>
                                        <option value="en">{t("users.language_english")}</option>
                                    </Form.Control>
                                </InputGroup>
                                <InputGroup className="mb-3">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>{t("users.new_invoicinguserid")}:</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control type="text" placeholder={t("users.new_invoicinguserid")} onChange={evt => setUser({...user, invoicingUserId: evt.target.value})} value={user["invoicingUserId"]} ></Form.Control>
                                </InputGroup>
                                <Button onClick={saveUser}>
                                    {t("myaccount.saveBtn")}
                                </Button>
                            </div>
                        : null}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}
 
export default MyAccount;